export default class DtoDepartements {
    constructor(obj) {
        this.name = obj.name
        this.code = obj.code
    }
}